import { useState } from 'react';
import qs from 'query-string';
import NetworkError from './ApiError';
import { AT_API_KEY, AT_API_URL } from '../../utils/Config';
import { stripDiacritics } from '../../utils/Diacritics';
import { getAlias } from '../../services/AliasMacronService';

const useFetchTimetableRoutes = () => {
  const [timetableRoutes, setTimetableRoutes] = useState([]);

  const fetchOne = async (query, routeTypes) => {
    const response = await fetch(
      `${AT_API_URL}timetable/legacy/routes?${qs.stringify({
        search_string: query,
        route_types: routeTypes,
      })}`,
      {
        method: 'GET',
        headers: { 'Ocp-Apim-Subscription-Key': AT_API_KEY },
      },
    );

    if (!response.ok) {
      throw new NetworkError(
        response.status,
        `Network error: ${response.status}`,
      );
    }

    const data = await response.json();
    if (data.status !== 'OK') {
      throw new NetworkError(
        data.status,
        `Network error: ${response.status}`,
        data.error,
      );
    }

    return data.response || [];
  };

  const fetchTimetableRoutes = async (query, routeTypes) => {
    const trimmedQuery = (query ?? '').trim();

    if (!trimmedQuery) {
      setTimetableRoutes({ results: [], isFetching: false });
      return;
    }

    setTimetableRoutes({ results: [], isFetching: true });

    const normalizedQuery = stripDiacritics(trimmedQuery);
    const alias = getAlias(trimmedQuery);

    try {
      if (alias) {
        const [queryResults, aliasResults] = await Promise.all([
          fetchOne(normalizedQuery, routeTypes),
          fetchOne(alias, routeTypes),
        ]);

        setTimetableRoutes({
          results: queryResults.concat(aliasResults),
          isFetching: false,
        });
        return;
      }

      const queryResults = await fetchOne(normalizedQuery, routeTypes);
      setTimetableRoutes({ results: queryResults, isFetching: false });
    } catch (error) {
      setTimetableRoutes({ results: [], isFetching: false });
      throw error;
    }
  };

  return [timetableRoutes, fetchTimetableRoutes];
};

export default useFetchTimetableRoutes;
